import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/sucursales', label: 'Sucursales' },
  { path: '/menu', label: 'Menú' },
  { path: '/nosotros', label: 'Nosotros' },
  { path: '/contacto', label: 'Contacto' },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="fixed top-0 left-0 w-full h-[100px] bg-[#05603c] z-[1000]">
      {/* Franja tricolor bandera de México */}
      <div className="absolute top-0 left-0 w-full h-[6px] flex z-[1001]">
        <span className="flex-1 bg-[#006847]" />
        <span className="flex-1 bg-white" />
        <span className="flex-1 bg-[#ce1126]" />
      </div>

      <div className="relative flex items-center justify-center w-full max-w-[1200px] h-full mx-auto px-5 gap-4">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img
              src="/mamas/logo-s.png"
              alt="El Chel Logo"
              className="h-[clamp(65px,8vw,90px)] w-auto"
            />
          </Link>
        </div>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center list-none gap-10 m-0 p-0">
          {navItems.map(({ path, label }) => (
            <li key={path}>
              <Link
                to={path}
                className={`no-underline text-[clamp(13px,1.7vw,22px)] uppercase font-[Poppins,sans-serif] px-4 py-2.5 rounded transition-colors duration-300 ${
                  location.pathname === path
                    ? 'text-white bg-brand-deep'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Hamburger button (mobile) */}
        <div
          className="md:hidden flex flex-col justify-between w-10 h-[30px] cursor-pointer absolute right-[60px] top-1/2 -translate-y-1/2"
          onClick={toggleMenu}
        >
          <span className="block h-1 w-full bg-[#ff6d00] rounded-[9px]" />
          <span className="block h-1 w-full bg-[#ff6d00] rounded-[9px]" />
          <span className="block h-1 w-full bg-[#ff6d00] rounded-[9px]" />
        </div>
      </div>

      {/* Side Menu */}
      <div
        className={`fixed top-0 right-0 w-3/4 max-w-[300px] h-full flex flex-col p-5 text-white z-[1000] transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{
          background: 'linear-gradient(to bottom, #05603c, #033f28)',
          boxShadow: '-2px 0 5px rgba(0,0,0,0.5)',
        }}
      >
        {/* Logo in side menu */}
        <div className="flex justify-center">
          <Link to="/" onClick={toggleMenu}>
            <img
              src="/mamas/logo-s.png"
              alt="El Chel Logo"
              className="h-[150px] w-auto"
            />
          </Link>
        </div>

        {/* Close button */}
        <div
          className="absolute top-5 right-5 w-[30px] h-[30px] cursor-pointer flex items-center justify-center z-[1001]"
          onClick={toggleMenu}
        >
          <div className="absolute w-full h-1 bg-white rounded rotate-45" />
          <div className="absolute w-full h-1 bg-white rounded -rotate-45" />
        </div>

        {/* Side nav links */}
        <ul className="list-none flex-grow flex flex-col justify-center gap-6 m-0 p-0">
          {navItems.map(({ path, label }) => (
            <li key={path} className="text-center">
              <Link
                to={path}
                onClick={toggleMenu}
                className={`no-underline text-xl font-bold transition-colors duration-300 ${
                  location.pathname === path ? 'text-[#ff6d00]' : 'text-white hover:text-[#ff6d00]'
                }`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
